import { graphql, useStaticQuery } from 'gatsby';

export function useTopCompanies() {
  const {
    topCompanies: { casesAmount, childrenTopCompany: projects },
  } = useStaticQuery(graphql`
    query {
      topCompanies {
        casesAmount
        childrenTopCompany {
          ...TopCompanyItem
        }
      }
    }
  `);

  return { casesAmount, projects };
}
